import api from "./api";

export type PincodeLocation = {
  city: string;
  state?: string;
  country_code: string;
};

type LocationsResponse = {
  count?: number;
  data?: Array<{
    pincode?: string;
    city?: string;
    state?: string;
    country_code?: string;
  }>;
};

const PINCODE_PATTERN = /^[1-9][0-9]{5}$/;

export function isLikelyPincode(value: string): boolean {
  return PINCODE_PATTERN.test(value);
}

export type PincodeAuthMode = "vendor" | "bouncer";

export async function fetchPincodeLocation(
  pincode: string,
  opts: { auth?: PincodeAuthMode } = {},
): Promise<PincodeLocation | null> {
  if (!isLikelyPincode(pincode)) return null;
  const auth = opts.auth ?? "vendor";
  const config =
    auth === "vendor"
      ? { useVendorToken: true }
      : { skipAuthRefreshOn401: true };
  try {
    const res = (await api.get(
      `/community/locations/api/v3/location?filters=pincode.eq:${encodeURIComponent(pincode)}`,
      config,
    )) as LocationsResponse | null;
    const first = res?.data?.[0];
    if (!first?.city) return null;
    return {
      city: first.city,
      state: first.state,
      country_code: first.country_code ?? "IN",
    };
  } catch {
    return null;
  }
}
